<template>
  <pt-detection-corpus-structure-update class="pt-detection-corpus-structure-update__withData"></pt-detection-corpus-structure-update>
</template>

<script>
import PtDetectionCorpusStructureUpdate from './index'
export default {
  name: 'pt-detection-corpus-structure-update__withData',
  components: {
    'pt-detection-corpus-structure-update': PtDetectionCorpusStructureUpdate
  }
}
</script>
